<template>
  <div>
    <a-button class="top_btn" type="primary" @click="()=>{visibleForm = true; titleForm='添加菜单'; this.ids='0'; this.editId=''; }" v-has="'btn_add'">
      添加
    </a-button>
    <a-table
        :columns="columns"
        :data-source="treeData"
        :loading="loading"
        :pagination="false"
        rowKey="id"
        :indent="24"
    >
      <span slot="action" slot-scope="text, record">
        <i v-if="$_hasAll(['btn_edit','btn_delete','btn_add'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record) => { visibleForm = true; titleForm='添加子菜单'; ids=text.id; editId=''; }" v-has="'btn_add'">添加子菜单<a-divider type="vertical"/></a>
        <a @click="(record)=>{ editId=text.id; visibleForm = true; titleForm='修改菜单';  }" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
        <a-popconfirm
            title="此操作将永久删除, 是否继续?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="confirm(record)"
            @cancel="()=>{}"
        >
          <a v-has="'btn_delete'">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <KshMenuForm
        :visible="visibleForm"
        :title="titleForm"
        :ids="ids"
        :editId="editId"
        @changVisible=" () => { this.visibleForm = false; this.ids=''; this.editId=''; this.getList(); }"
    ></KshMenuForm>
  </div>
</template>

<script>
import API from "./api";
import KshMenuForm from "./components/KshMenuForm";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    width: "10%",
    key: "id"
  },
  {
    title: "菜单名称",
    dataIndex: "name",
    ellipsis: true,
    key: "name",
    width: '450px'
  },
  {
    title: "类型",
    dataIndex: "component_type",
    key: "component_type",
    ellipsis: true
  },
  {
    title: "操作",
    key: "action",
    width: "250px",
    scopedSlots: {customRender: "action"}
  }
];

export default {
  name: "KshRoleMenuList",
  data() {
    return {
      loading: true,
      visibleForm: false,
      titleForm: "",
      ids: "",
      editId: "",
      data: [],
      treeData: [],
      columns
    };
  },
  components: { KshMenuForm },
  created() {
    this.$store.state.adminleftnavnum = "/Menu/KshRoleMenuList";
  },
  mounted() {
    console.log(2222)
    this.getList();
  },
  methods: {
    confirm(row) {
      API.menu.KSH_MENU_DELETE([row.id]).then(res => {
        if (res.data.code === 200) {
          this.$message.success("删除成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(() => {
        this.$message.error("删除失败");
      });
    },
    getList() {
      this.loading = true;
      API.menu.KSH_MENU_LIST().then(res => {
        const { data, code} = res.data
        if (code === 1) {
          data.list.map((item, index) => {
            item.key = item.id;
            if (item.children && item.children.length > 0) {
              item.children.map((items, indexs) => {
                items.key = items.id;
              });
            }
          });
          this.treeData = data.list;
        } else {
          this.treeData = [];
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.treeData = [];
      });
    }
  }
};
</script>

<style scoped>
.top_btn {
  margin-bottom: 16px;
}
</style>
